module.exports = __webpack_public_path__ + "img/pcbanner.2d8d8185.jpg";